module.exports = __webpack_public_path__ + "img/2012-12-14 20.01.56.eb70f12c.jpg";